import React from 'react';
import { Link } from 'react-router-dom';
import './Mastery.css';

/**
 * Dashboard entry to 闯关, pinned above 今日作业: always there, never a task that reads as
 * unfinished. Static, so the dashboard makes no extra request for it.
 */
export function MasteryCard() {
  return (
    <Link to="/mastery" className="mq-card">
      <span className="mq-card__icon" aria-hidden="true">🏆</span>
      <span className="mq-card__info">
        <span className="mq-card__title">单词大冒险 🚀</span>
        <span className="mq-card__sub">随时来闯关 · 点亮圆点赢 🎁 +100</span>
      </span>
      <span className="mq-card__go" aria-hidden="true">▶</span>
    </Link>
  );
}
